import React from "react";

interface ILogo {
  width?: string;
  height?: string;
}
const Logo = ({ width, height }: ILogo) => {
  return (
    <div
      style={{
        background: "white",
        width: width || "20px",
        height: height || "20px",
        borderRadius: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <svg
        width={width || "20"}
        height={height || "20"}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 10.9263C9.49474 10.9263 9.07368 10.5053 9.07368 10C9.07368 9.49474 9.49474 9.07368 10 9.07368C10.5053 9.07368 10.9263 9.49474 10.9263 10C10.9263 10.5053 10.5053 10.9263 10 10.9263ZM20 10C20 15.5158 15.5158 20 10 20C4.48421 20 0 15.5158 0 10C0 4.48421 4.48421 0 10 0C15.5158 0 20 4.48421 20 10ZM10 17.2632C9.85263 17.2632 9.74737 17.3684 9.74737 17.5158C9.74737 17.6632 9.85263 17.7684 10 17.7684C14.2737 17.7684 17.7474 14.2947 17.7474 10.0211C17.7474 9.87368 17.6421 9.76842 17.4947 9.76842C17.3474 9.76842 17.2421 9.87368 17.2421 10.0211C17.2632 14 14 17.2632 10 17.2632ZM16 10C16 13.3053 13.3053 16 10 16C9.85263 16 9.74737 16.1053 9.74737 16.2526C9.74737 16.4 9.85263 16.5053 10 16.5053C13.6 16.5053 16.5053 13.5789 16.5053 10C16.5053 9.85263 16.4 9.74737 16.2526 9.74737C16.1263 9.74737 16 9.85263 16 10ZM14.7579 10C14.7579 12.6316 12.6316 14.7579 10 14.7579C9.85263 14.7579 9.74737 14.8632 9.74737 15.0105C9.74737 15.1579 9.85263 15.2632 10 15.2632C12.9053 15.2632 15.2632 12.9053 15.2632 10C15.2632 9.85263 15.1579 9.74737 15.0105 9.74737C14.8842 9.74737 14.7579 9.85263 14.7579 10ZM1.49474 10C1.49474 5.30526 5.30526 1.49474 10 1.49474C10.1474 1.49474 10.2526 1.38947 10.2526 1.24211C10.2526 1.09474 10.1474 0.989474 10 0.989474C5.03158 0.989474 0.989474 5.03158 0.989474 10C0.989474 10.1474 1.09474 10.2526 1.24211 10.2526C1.38947 10.2526 1.49474 10.1474 1.49474 10ZM10 2.73684C10.1474 2.73684 10.2526 2.63158 10.2526 2.48421C10.2526 2.33684 10.1474 2.23158 10 2.23158C5.72632 2.23158 2.25263 5.70526 2.25263 9.97895C2.25263 10.1263 2.35789 10.2316 2.50526 10.2316C2.65263 10.2316 2.75789 10.1263 2.75789 9.97895C2.73684 6 6 2.73684 10 2.73684ZM4 10C4 6.69474 6.69474 4 10 4C10.1474 4 10.2526 3.89474 10.2526 3.74737C10.2526 3.6 10.1474 3.49474 10 3.49474C6.4 3.49474 3.49474 6.42105 3.49474 10C3.49474 10.1474 3.6 10.2526 3.74737 10.2526C3.87368 10.2526 4 10.1474 4 10ZM5.24211 10C5.24211 7.36842 7.36842 5.24211 10 5.24211C10.1474 5.24211 10.2526 5.13684 10.2526 4.98947C10.2526 4.84211 10.1474 4.73684 10 4.73684C7.09474 4.73684 4.73684 7.09474 4.73684 10C4.73684 10.1474 4.84211 10.2526 4.98947 10.2526C5.11579 10.2526 5.24211 10.1474 5.24211 10ZM10 13.7684C12.0842 13.7684 13.7684 12.0842 13.7684 10C13.7684 7.91579 12.0842 6.23158 10 6.23158C7.91579 6.23158 6.23158 7.91579 6.23158 10C6.23158 12.0842 7.91579 13.7684 10 13.7684ZM19.0105 10C19.0105 9.85263 18.9053 9.74737 18.7579 9.74737C18.6105 9.74737 18.5053 9.85263 18.5053 10C18.5053 14.6947 14.6947 18.5053 10 18.5053C9.85263 18.5053 9.74737 18.6105 9.74737 18.7579C9.74737 18.9053 9.85263 19.0105 10 19.0105C14.9684 19.0105 19.0105 14.9684 19.0105 10Z"
          fill="url(#paint0_linear_451_1060)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_451_1060"
            x1="0"
            y1="0"
            x2="20"
            y2="0"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#EF4136" />
            <stop offset="1" stopColor="#FBB040" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};

export default Logo;
